module.exports = __webpack_public_path__ + "static/img/MELBOURNE.b7a84f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MELBOURNE.svg
// module id = ji0/
// module chunks = 0